// Modifier A section form field enum
export enum ModifierAFormField {
  MODIFIER_A_1_QUESTION = 'modifierA/question1',
  MODIFIER_A_1_NOTES = 'modifierA/notes1',
  MODIFIER_A_2_QUESTION = 'modifierA/question2',
  MODIFIER_A_2_NOTES = 'modifierA/notes2',
  MODIFIER_A_3_QUESTION = 'modifierA/question3',
  MODIFIER_A_3_NOTES = 'modifierA/notes3',
  MODIFIER_A_4_QUESTION = 'modifierA/question4',
  MODIFIER_A_4_NOTES = 'modifierA/notes4'
}
